const capUtils = {};

//与原生app交互的类
import { Plugins, AppState, StatusBarStyle } from "@capacitor/core";

const { App, Browser, Clipboard, Device, Share, StatusBar, SplashScreen, LocalNotifications, Geolocation, JoyInfo } = Plugins;

// const info = Device.getInfo();
// console.log(info);
//
// const _info = Device.getBatteryInfo();
// console.log(_info);

capUtils.downApp = async function (url) {
    await JoyInfo.downloadApp({ down_url: url });
}

capUtils.saveImg = async function (url, fn) {
    let save_result = await JoyInfo.saveImg({ img_url: url });
    if (fn) {
        fn(save_result)
    }
}

capUtils.splashScreenHide = function () {
    SplashScreen.hide();
}

/**
 * 设备信息
 */
capUtils.getDeviceInfo = async function (fn) {
    let _info = await Device.getInfo();
    if (fn) {
        fn(_info)
    }
    return _info
}

/**
 * 电池信息
 */
capUtils.getBatteryInfo = async function () {
    let _batteryInfo = await Device.getBatteryInfo();
    return _batteryInfo
}


capUtils.onAppStateChange = function (fn) {
    App.addListener('appStateChange', (state) => {
        // state.isActive contains the active state
        console.log('App state changed. Is active?', state.isActive);
        if (fn) {
            fn(state)
        }
    });
}

/**
 * Gets the current app state
 */
capUtils.getCurrentAppState = function () {
    let ret = App.getState();
}

/**
 * 退出App
 */
capUtils.exitApp = function () {
    App.exitApp()
}


/**
 * 判断url/URLScheme是否能打开，不确定在iOS上是否能用
 * @param {*} url
 */
capUtils.canOpenUrl = async function (url) {
    if (url) {
        var ret = await App.canOpenUrl({ url: url });
        return ret
    }
}

/**
 * 呼出url/URLScheme
 * @param {*} url
 */
capUtils.openUrl = async function (url, fn) {
    if (url) {
        App.addListener('appUrlOpen', data => {
            console.log('App opened with URL: ' + data.url);
            if (fn) {
                fn(data)
            }
        });

        let ret = await App.openUrl({ url: url });
        return ret
    }
}

/**
 * 用内置浏览器打开一个url
 * @param {*} _url
 */
capUtils.openBrowserUrl = async function (_url) {
    let browserOpenOptions = {
        url: _url,
        windowName: "京东",
        presentationStyle: "fullscreen"
    }
    await Browser.open(browserOpenOptions);
    // BrowserOpenOptions {
    //   // iOS only: The presentation style of the browser. Defaults to fullscreen.
    //   presentationStyle ?: any;
    //   // A hex color to set the toolbar color to.
    //   toolbarColor ?: string;
    //   // The URL to open the browser to
    //   url: string;
    //   // Web only: Optional target for browser open. Follows the `target` property for window.open. Defaults to _blank
    //   windowName ?: string;
    // }
}

/**
 * 获取当前打开的url
 */
capUtils.getLaunchUrl = async function () {
    let ret = await App.getLaunchUrl();
    if (ret && ret.url) {
        return ret.url
    }
}

/**
 * 读取粘贴板
 */
capUtils.readClipboard = async function (fn) {
    // if(Clipboard){
    //     let result = await Clipboard.read();
    //     if (fn) {
    //         fn(result)
    //     }
    //     return result
    // }
    Clipboard.read().then(result => {
        if (fn) {
            fn(result)
        }
    }).catch(error => {
        console.log(error)
    })

}

capUtils.writeClipboard = function (text) {
    if (text) {
        Clipboard.write({
            string: text
        });
    }
}

/**
 * 显示分享
 * @param {*} _title
 * @param {*} _text
 * @param {*} _url
 * @param {*} _dialogTitle
 */
capUtils.showShare = function (_title, _text, _url, _dialogTitle) {
    let shareRet = Share.share({
        title: _title,
        text: _text,
        url: _url,
        dialogTitle: _dialogTitle,
    });
}

/**
 * 本地通知？不确定
 */
capUtils.localNotifications = async function () {

    let localNote = await LocalNotifications.schedule({
        notifications: [
            {
                title: "On sale",
                body: "Widgets are 10% off. Act fast!",
                id: 1,
                schedule: { at: new Date(Date.now() + 1000 * 10) },
                sound: null,
                attachments: null,
                actionTypeId: "",
                extra: null,
            },
        ],
    });

    LocalNotifications.areEnabled();
}

/**
 * 获取当前位置
 * @returns {Promise<void>}
 */
capUtils.getCurrentPosition = async function (fn) {
    // let result = await Geolocation.getCurrentPosition();
    // console.log(result)
    // if(fn){
    //     fn(result);
    // }
    Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 10,
        timeout: 1500,
    }).then(result => {
        console.log(result)
        if (fn) {
            fn(result)
        }
    }).catch(error => {
        console.log(error)
        if (fn) {
            fn(error)
        }
    })
}

/**
 * 获取android设备的imei
 * @param fn
 * @returns {Promise<void>}
 */
capUtils.getID = async function (fn) {
    let result = await JoyInfo.getID()
    if (fn) {
        fn(result)
    }
    // {
    //     "os":"android",
    //     "imei":"",
    //     "idfa":"",
    //     "oaid":"",
    //     "vaid":"",
    //     "aaid":""
    // }
}


export default capUtils;